import React from 'react';
import { IOldIconProps } from './type';

const Checked: React.FC<IOldIconProps> = ({
  width = 10,
  height = 10,
  color = '#FFCB03',
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 5C10 7.76142 7.76142 10 5 10C2.23858 10 0 7.76142 0 5C0 2.23858 2.23858 0 5 0C7.76142 0 10 2.23858 10 5Z"
        fill={color}
      />
      <path
        d="M4.05581 7C4.0062 7 3.95969 6.99142 3.91628 6.97425C3.87287 6.95708 3.83256 6.93133 3.79535 6.897L2.11163 5.34335C2.03721 5.27468 2 5.1917 2 5.09442C2 4.99714 2.03721 4.91416 2.11163 4.84549C2.18605 4.77682 2.27442 4.74249 2.37674 4.74249C2.47907 4.74249 2.56744 4.77682 2.64186 4.84549L4.05581 6.15021L7.36744 3.103C7.43566 3.03433 7.52093 3 7.62326 3C7.72558 3 7.81395 3.03433 7.88837 3.103C7.96279 3.17167 8 3.25465 8 3.35193C8 3.44921 7.96279 3.52933 7.88837 3.59227L4.31628 6.897C4.27907 6.93133 4.23876 6.95708 4.19535 6.97425C4.15194 6.99142 4.10543 7 4.05581 7Z"
        fill="black"
      />
    </svg>
  );
};

export default Checked;
